import { useState } from "react";
import { useOracle } from "@/contexts/OracleContext";
import { motion } from "framer-motion";
import { oraclePhrases } from "@/constants/oraclePhrases";
import { oracleAnswers } from "@/constants/oracleAnswers";
import { 
  ChevronLeft, Sparkles, Bell, 
  Target, Zap, ShoppingCart, 
  Clock, CheckCircle2, Info,
   Copy, Share2, Check 
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext"; 
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
// Adicione estes imports (ajuste o caminho do @/lib/firebase se necessário)
import { db } from "@/lib/firebase"; 
import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import { useEffect } from "react"; // Adicione o useEffect se não estiver lá

// Funções de Padronização Financeira
const handleCurrencyInputChange = (value, callback) => {
  const cleanValue = value.replace(/\D/g, "");
  const floatValue = parseFloat(cleanValue) / 100;
  if (isNaN(floatValue)) {
    callback("0");
  } else {
    callback(floatValue.toString());
  }
};

const displayMask = (value) => {
  if (!value) return "";
  return new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: 2,
  }).format(parseFloat(value));
};

export default function Notifications() {
  const { isOracleActive } = useOracle();
  const navigate = useNavigate();


  
  // Estados de Controle
  const { user } = useAuth(); // Certifique-se que o user está vindo do useAuth()
  const [selectedDays, setSelectedDays] = useState([]);
  const [score] = useState(120);
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);
  const [oracleStep, setOracleStep] = useState(1);
  const [purchaseData, setPurchaseData] = useState({ name: "", price: "", type: "" });
  const [oracleAnswer, setOracleAnswer] = useState("");
   // 1. Carregar os dias do Firebase ao abrir a página
  useEffect(() => {
    const loadJuramentoDays = async () => {
      if (!user?.uid) return;
      try {
        const docRef = doc(db, "users", user.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists() && docSnap.data().oraclePactDays) {
          setSelectedDays(docSnap.data().oraclePactDays);
        }
      } catch (error) {
        console.error("Error loading oracle pact days:", error);
      }
    };
    loadJuramentoDays();
  }, [user?.uid]);

  // 2. Função de Toggle atualizada para salvar no Firebase
  const toggleDay = async (day) => {
    if (!user?.uid) return;

    const newDays = selectedDays.includes(day)
      ? selectedDays.filter(d => d !== day)
      : [...selectedDays, day];

    // Atualiza o estado local para resposta rápida (UI)
    setSelectedDays(newDays);

    // Salva no Firebase
    try {
      const userRef = doc(db, "users", user.uid);
      await setDoc(userRef, { oraclePactDays: newDays }, { merge: true });
    } catch (error) {
      console.error("Error saving oracle pact days:", error);
    }
  };

  // Lógica da Frase de Sabedoria
  const [randomPhrase, setRandomPhrase] = useState(() => {
    return oraclePhrases[Math.floor(Math.random() * oraclePhrases.length)];
  });

  const refreshPhrase = () => {
    const newIndex = Math.floor(Math.random() * oraclePhrases.length);
    setRandomPhrase(oraclePhrases[newIndex]);
  };

  // Lógica da Bola 8 (Oráculo)
 const handleOracleAsk = () => {
    const price = parseFloat(purchaseData.price) || 0;
    const type = purchaseData.type; // 'necessidade' ou 'desejo'
    let range = "";

    // 1. Identifica a faixa de preço
    if (price <= 30) range = "0_30";
    else if (price <= 100) range = "31_100";
    else if (price <= 300) range = "101_300";
    else if (price <= 700) range = "301_700";
    else if (price <= 1500) range = "701_1500";
    else if (price <= 3000) range = "1501_3000";
    else range = "plus_3000";

    // 2. Monta o nome da lista (Ex: necessidade_31_100 ou superfulo_plus_3000)
    // Nota: no seu botão, o valor é 'desejo', mas no objeto chamamos de 'superfulo'
    const listKey = `${type === 'necessidade' ? 'necessidade' : 'superfulo'}_${range}`;
    
    const selectedList = oracleAnswers[listKey] || oracleAnswers.superfulo_0_30;

    // 3. Sorteia a frase
    const randomIndex = Math.floor(Math.random() * selectedList.length);
    let finalAnswer = selectedList[randomIndex];
    
    // 4. Formata o preço
    const formattedPrice = new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(price);

    // 5. Substitui os placeholders
    finalAnswer = finalAnswer
      .replace(/{name}/g, purchaseData.name.toLowerCase())
      .replace(/{price}/g, formattedPrice);
    
    setOracleAnswer(finalAnswer);
    setOracleStep(3);
  };

  const resetOracle = () => {
    setOracleStep(1);
    setPurchaseData({ name: "", price: "", type: "" });
    setOracleAnswer("");
  };

  // --- INICIO DO BLOCO NOVO ---
  const [copied, setCopied] = useState(false);

 const copyToClipboard = async () => {
    try {
      const cleanAnswer = oracleAnswer.replace(/"/g, '');
      await navigator.clipboard.writeText(
        `🔮 Oráculo do Troquinho diz:\n\n${cleanAnswer}\n\nEconomize com o app Troquinho! 🐷`
      );
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Erro ao copiar", err);
    }
  };

const shareContent = async () => {
    // Formatação especial para WhatsApp (asteriscos fazem o negrito)
    const shareText = `🔮 *ORÁCULO DO TROQUINHO* \n\n` +
                      `${oracleAnswer.replace(/"/g, '')}\n\n` + // Remove aspas se sobrarem
                      `__________________________\n` +
                      `Sentenciado por: *App Troquinho* 🐷`;

    const shareData = {
      title: 'Oráculo Troquinho',
      text: shareText,
      url: window.location.origin, 
    };

    try {
      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        copyToClipboard();
      }
    } catch (err) {
      console.log("Erro ao compartilhar", err);
    }
  };
  // --- FIM DO BLOCO NOVO ---

    return (
    <div className={`h-[100dvh] w-full fixed inset-0 overflow-hidden flex flex-col transition-colors duration-500 ${isOracleActive ? 'bg-indigo-50/50' : 'bg-slate-50'}`}>
      <div className="flex-1 overflow-y-auto overscroll-touch px-5 pt-6 pb-32">
        <div className="max-w-lg mx-auto">
        
        {/* Header */}
        <header className="flex items-center gap-4 mb-8">
          <Button 
            variant="ghost" 
            size="icon" 
            onClick={() => navigate(-1)}
            className="rounded-full bg-white shadow-sm"
          >
            <ChevronLeft className="w-5 h-5 text-slate-600" />
          </Button>
          <h1 className="text-xl font-black text-slate-900">Central do Oráculo</h1>
        </header>

        {/* Pacto de Comprometimento - Estilo Home */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white rounded-[24px] p-5 shadow-sm border border-slate-100 mb-5"
        >
          <div className="flex items-start justify-between mb-4">
            <div className="flex gap-3">
              <div className="w-10 h-10 rounded-2xl bg-indigo-500 flex items-center justify-center flex-shrink-0 shadow-lg shadow-indigo-500/20">
                <Sparkles className="w-5 h-5 text-white" />
              </div>
              <div>
                <h2 className="text-xl font-black tracking-tight text-slate-900 leading-none mb-1">
                  Juramento do Troquinho
                </h2>
                <p className="text-indigo-500 font-medium text-xs">
                  Jura de dedinho que vai usar o app? 🤙
                </p>
              </div>
            </div>
          </div>

          <p className="text-sm font-medium text-slate-600 mb-5 leading-snug">
            Para o <b>Troquinho</b> te ajudar, escolha os dias que você vai entrar para organizar a vida financeira:
          </p>

          {/* Seleção de Dias Estilo Toggle da Home */}
          <div className="flex justify-between items-center bg-slate-50 rounded-2xl p-1.5 border border-slate-100 mb-5">
            {['D', 'S', 'T', 'Q', 'Q', 'S', 'S'].map((day, index) => {
              const dayNames = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'];
              const isSelected = selectedDays.includes(dayNames[index]);
              return (
                <button
                  key={dayNames[index]}
                  onClick={() => toggleDay(dayNames[index])}
                  className={`flex-1 flex items-center justify-center h-10 rounded-xl font-black text-xs transition-all ${
                    isSelected 
                      ? "bg-indigo-500 text-white shadow-lg shadow-indigo-200"
                      : "text-slate-400 hover:bg-white"
                  }`}
                >
                  {day}
                </button>
              );
            })}
          </div>

          <div className="bg-gradient-to-r from-amber-50 to-orange-50 rounded-[20px] p-4 border border-amber-100/50">
            <p className="text-xs font-medium text-amber-800 leading-relaxed">
              ✨ <b>Dica do Oráculo:</b> A gente sabe que é corrido, mas faça pelo menos 1x na semana para não surtar no final do mês!
            </p>
          </div>
        </motion.div>

        {/* Card Sabedoria */}
        <div className="grid grid-cols-1 gap-4 mb-6">
          {/* Card Sabedoria Padronizado */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          onClick={refreshPhrase}
          className="bg-gradient-to-r from-indigo-50 to-violet-50 rounded-[24px] p-4 mb-6 flex items-center gap-4 cursor-pointer active:scale-95 transition-transform border border-indigo-100/50"
        >
          <div className="w-10 h-10 rounded-2xl bg-violet-500 flex items-center justify-center flex-shrink-0 shadow-lg shadow-violet-500/30">
            <Sparkles className="w-5 h-5 text-white" />
          </div>
          <div className="flex-1">
            <p className="text-[10px] font-black text-indigo-400 uppercase tracking-wider mb-0.5">
              Sabedoria do Oráculo
            </p>
            <p className="text-sm font-bold text-slate-700 leading-snug tracking-tight">
              "{randomPhrase}"
            </p>
          </div>
        </motion.div>
        </div>

        {/* Arena do Oráculo */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-slate-900 rounded-[32px] p-6 shadow-xl relative overflow-hidden"
        >
          <div className="absolute top-0 right-0 w-32 h-32 bg-indigo-500/10 rounded-full blur-3xl" />
          <div className="relative z-10 text-white">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-full bg-indigo-500 flex items-center justify-center animate-pulse">
                <Sparkles className="w-5 h-5 text-white" />
              </div>
              <h3 className="font-black italic">Consultor Oráculo</h3>
            </div>

            <div className="min-h-[200px] flex flex-col justify-center">
              {oracleStep === 1 && (
                <div className="space-y-4 text-white">
                  <p className="text-indigo-200 text-sm font-medium text-white">Dúvida cruel? O que você quer comprar?</p>
                  <input 
                    placeholder="O que é? (Ex: Sushi, Tênis...)"
                    className="w-full bg-white/5 rounded-[20px] p-4 border border-white/10 outline-none focus:border-indigo-500 text-white placeholder:text-slate-600 text-base"
                    onChange={(e) => setPurchaseData({...purchaseData, name: e.target.value})}
                  />
                  <div className="relative">
                    <span className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-500 text-sm font-bold">R$</span>
                    <input 
                      type="text"
                      inputMode="decimal"
                      placeholder="0,00"
                      value={displayMask(purchaseData.price)}
                      className="w-full bg-white/5 rounded-[20px] p-4 pl-10 border border-white/10 outline-none focus:border-indigo-500 text-white placeholder:text-slate-600 text-base font-bold"
                      onChange={(e) => handleCurrencyInputChange(e.target.value, (val) => setPurchaseData({...purchaseData, price: val}))}
                    />
                  </div>
                  <Button 
                    className="w-full rounded-[20px] bg-indigo-600 hover:bg-indigo-700 h-12 font-bold" 
                    onClick={() => setOracleStep(2)}
                    disabled={!purchaseData.name || !purchaseData.price}
                  >
                    Continuar
                  </Button>
                </div>
              )}

             {oracleStep === 2 && (
  <div className="space-y-4 animate-in fade-in slide-in-from-right-4">
    {/* Alteração do texto da pergunta abaixo */}
    <p className="text-indigo-100 text-sm font-medium leading-relaxed">
      Sendo sincero, <span className="text-white font-black italic underline decoration-indigo-500">"{purchaseData.name}"</span> é... <br/>
      <span className="text-indigo-300 text-xs uppercase tracking-wider">Necessidade ou Vontade?</span>
    </p>
    
    <div className="grid grid-cols-1 gap-2">
      <button 
  onClick={() => setPurchaseData({...purchaseData, type: 'necessidade'})}
  className={`p-4 rounded-[20px] border text-left text-sm font-bold transition-all ${purchaseData.type === 'necessidade' ? 'bg-indigo-600 border-indigo-400 text-white shadow-lg shadow-indigo-500/20' : 'bg-white/5 border-white/10 text-slate-400'}`}
>📦 Necessidade</button> {/* Troquei 🍎 por 📦 para ser mais neutro (essenciais/casa) */}

<button 
  onClick={() => setPurchaseData({...purchaseData, type: 'desejo'})}
  className={`p-4 rounded-[20px] border text-left text-sm font-bold transition-all ${purchaseData.type === 'desejo' ? 'bg-indigo-600 border-indigo-400 text-white shadow-lg shadow-indigo-500/20' : 'bg-white/5 border-white/10 text-slate-400'}`}
>✨ Só Vontade</button> {/* Troquei 💅 por ✨ e adicionei o "Só" para reforçar o tom do Oráculo */}
    </div>
    
    <Button className="w-full rounded-[20px] bg-white text-slate-900 h-12 font-bold mt-2 hover:bg-indigo-50" onClick={handleOracleAsk}>
      Consultar Destino
    </Button>
  </div>
)}

              {oracleStep === 3 && (
                <div className="text-center space-y-6 animate-in zoom-in-95 duration-500">
                  <div className="text-5xl mb-2">🔮</div>
                  
                  {/* Área da Frase com destaque */}
                  <div className="bg-white/10 p-6 rounded-[24px] border border-white/10 backdrop-blur-sm">
                    <p className="text-indigo-50 text-lg italic leading-relaxed font-medium">
                      {oracleAnswer}
                    </p>
                  </div>

                  {/* Botões de Ação */}
                  <div className="flex flex-col gap-3">
                    <div className="grid grid-cols-2 gap-3">
                      <Button 
                        variant="outline"
                        onClick={copyToClipboard}
                        className="rounded-2xl bg-white/5 border-white/20 text-white hover:bg-white/10 h-12"
                      >
                        {copied ? <Check className="w-4 h-4 mr-2 text-emerald-400" /> : <Copy className="w-4 h-4 mr-2" />}
                        {copied ? "Copiado!" : "Copiar"}
                      </Button>

                      <Button 
                        onClick={shareContent}
                        className="rounded-2xl bg-indigo-500 hover:bg-indigo-600 text-white border-none h-12 shadow-lg shadow-indigo-500/20"
                      >
                        <Share2 className="w-4 h-4 mr-2" />
                        Compartilhar
                      </Button>
                    </div>

                    <Button 
                      variant="ghost" 
                      className="text-slate-400 hover:text-white font-bold" 
                      onClick={resetOracle}
                    >
                      Fazer outra pergunta
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </motion.div>

        {/* Modal de Explicação */}
        <Dialog open={isInfoModalOpen} onOpenChange={setIsInfoModalOpen}>
          <DialogContent className="rounded-[32px] border-none bg-white text-slate-900 max-w-[90vw] p-8 shadow-2xl">
            <DialogHeader>
              <DialogTitle className="text-left text-2xl font-black">Como pontuar?</DialogTitle>
            </DialogHeader>
            <div className="space-y-6 mt-4">
              <div className="flex gap-4">
                <div className="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center flex-shrink-0 text-xl">✨</div>
                <p className="text-sm text-slate-600"><b>Acesse todo dia:</b> 5 pontos de presença.</p>
              </div>
              <div className="flex gap-4">
                <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0 text-xl">📝</div>
                <p className="text-sm text-slate-600"><b>Checklist:</b> 10 pontos por conta paga.</p>
              </div>
              <div className="flex gap-4">
                <div className="w-10 h-10 rounded-full bg-indigo-100 flex items-center justify-center flex-shrink-0 text-xl">💰</div>
                <p className="text-sm text-slate-600"><b>Registros:</b> 10 pontos por novo lançamento.</p>
              </div>
              <Button className="w-full rounded-[20px] bg-slate-900 text-white h-14 font-bold" onClick={() => setIsInfoModalOpen(false)}>Bora!</Button>
            </div>
          </DialogContent>
        </Dialog>
        {/* Fim do conteúdo centralizado */}
        </div> 
      </div> 
    </div> 
  );
}